import { useState, useEffect, useContext, useRef } from 'react'
import ContextStates from '../../context/ContextStates'
import ReactToPrint from 'react-to-print';
import { FaPrint } from 'react-icons/fa'

const ViewVenta = (props) => {
    const [total, setTotal] = useState(0)
    const [totalDesc, setTotalDesc] = useState('')
    const [porcentajeDesc, setPorcentajeDesc] = useState('')
    const { ventaSelected, setFormView, setViewOpen } = useContext(ContextStates)
    const componentRef = useRef();

    useEffect(() => {
        if (ventaSelected.descuentos) {
            ventaSelected.descuentos.forEach(element => {
                if (element.tipo === '2') {
                    setPorcentajeDesc(element.valor)
                    let aux = ventaSelected.total - (ventaSelected.total * element.valor / 100)
                    setTotalDesc(aux)
                }
            });
        }
        const calcTotal = () => {
            let t = 0;
            if (typeof ventaSelected.productos !== 'undefined') {
                ventaSelected.productos.forEach(element => {
                    t = t + parseInt(element.monto)
                });
                setTotal(t)
            }
        }
        calcTotal()
    }, [ventaSelected])

    return (
        <>
            <div className='w-10/12 mx-auto'>
                <div className='print:px-4 print:text-xs print:h-svh' ref={componentRef}>
                    <div className='w-full mx-auto'>
                        <p className='text-center text-2xl mt-15 font-bold print:text-lg'>{ventaSelected.nombre}</p>
                        <p className='text-center text-xl print:text-lg uppercase'>{`${props.tipo !== 0 ? 'Presupuesto' : 'Recibo'}`} Nº {ventaSelected.numero}</p>
                        <p className='text-left print:pl-2 rounded-lg text-xl print:text-xs'>{`Cliente: ${ventaSelected.cliente}`}</p>
                        <p className='text-left print:pl-2 rounded-lg text-xl print:text-xs'>{`Dirección: ${ventaSelected.domicilio}`}</p>
                        <div className='w-full mt-3 mb-7'>
                            <div className='w-full print:pl-2'>
                                <p className='text-left'>Fecha {ventaSelected.fecha}</p>
                            </div>
                            {!props.tipo === 0 && (
                                <div className='w-full print:pl-2'>
                                    <p className='text-left'>Hora {ventaSelected.hora}</p>
                                </div>
                            )}
                        </div>
                    </div>

                    <table className='w-full mx-auto'>
                        <thead>
                            <tr className='p-1 bg-blue-400 text-white text-center'>
                                <th>Cod.</th>
                                <th>Descripción</th>
                                <th>Precio / U</th>
                                <th>Cantidad</th>
                                <th>Subtotal</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                typeof ventaSelected.productos !== 'undefined' && ventaSelected.productos.map((item, index) => (
                                    item.cantidad > 0 && (
                                        <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-100 text-center ${item.saldo && item.saldo > 0 && item.saldo === item.total ? 'bg-red-300' : item.saldo > 0 && item.saldo < item.total ? 'bg-orange-300' : index % 2 === 0 ? 'bg-white ' : 'bg-slate-100'} )`}>
                                            <td>{item.codigo}</td>
                                            <td>{item.descripcion}</td>
                                            <td>$ {parseFloat(item.precio).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                            <td>{item.cantidad}</td>
                                            <td>$ {parseFloat(item.monto).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                        </tr>
                                    )
                                ))
                            }
                        </tbody>
                    </table>
                    {(typeof ventaSelected.descuentos !== 'undefined' && ventaSelected.descuentos.length > 0) || porcentajeDesc !== '' && (
                        <div className='w-full'>
                            <p className='text-left font-bold uppercase text-3xl print:text-sm'>Descuentos</p>
                            <table className='w-full mx-auto'>
                                <thead>
                                    <tr className='p-1 bg-blue-400 text-white text-center'>
                                        <th>Descripción</th>
                                        <th>Monto</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        typeof ventaSelected.descuentos !== 'undefined' && ventaSelected.descuentos.map((item, index) => (
                                            <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-100 text-center ${item.saldo && item.saldo > 0 && item.saldo === item.total ? 'bg-red-300' : item.saldo > 0 && item.saldo < item.total ? 'bg-orange-300' : index % 2 === 0 ? 'bg-white ' : 'bg-slate-100'} )`}>
                                                <td>{item.label}</td>
                                                <td>$ {parseFloat(item.monto).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                            </tr>
                                        ))
                                    }
                                    {porcentajeDesc !== '' && porcentajeDesc !== 0 && (
                                        <tr className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-100 text-center`}>
                                            <td>Descuento del {porcentajeDesc}%</td>
                                            <td>-$ {(parseFloat(ventaSelected.total) - parseFloat(totalDesc)).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                    <div className='w-full flex'>
                        <div className='w-1/2 print:pl-2'>
                            <p className='text-left font-bold uppercase text-3xl print:text-sm'>Total</p>
                        </div>
                        <div className='w-1/2 print:pr-10'>
                            <p className='text-right font-bold uppercase text-3xl print:text-sm'>$ {parseFloat(ventaSelected.total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                        </div>
                    </div>
                    {porcentajeDesc !== '' && porcentajeDesc !== 0 && (
                        <>
                            <div className='w-full flex'>
                                <div className='w-1/2 print:pl-2'>
                                    <p className='text-left print:text-right font-bold uppercase text-3xl print:text-sm'>Descuento</p>
                                </div>
                                <div className='w-1/2 print:pr-4'>
                                    <p className='text-right font-bold uppercase text-3xl print:text-sm'>- $ {(parseFloat(total) - parseFloat(totalDesc)).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                                </div>
                            </div>
                            <div className='w-full flex'>
                                <div className='w-1/2 print:pl-2'>
                                    <p className='text-left print:text-right font-bold uppercase text-3xl print:text-sm'>Total a Pagar</p>
                                </div>
                                <div className='w-1/2 print:pr-4'>
                                    <p className='text-right font-bold uppercase text-3xl print:text-sm'>$ {parseFloat(totalDesc).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                                </div>
                            </div>
                        </>
                    )}
                </div>
                <div className="w-full mt-5 rounded-lg px-3 flex justify-center">
                    <ReactToPrint
                        trigger={() =>
                            <button
                                type="button"
                                className="w-1/3 sm:w-1/4 flex shadow-md p-3 ml-3 bg-indigo-500 text-white hover:bg-indigo-400 transition-all uppercase font-bold rounded-lg"
                            >
                                <FaPrint className='mx-auto mt-1' />
                                <p className='mx-auto text-center'>
                                    Imprimir Comprobante
                                </p>
                            </button>}
                        content={() => componentRef.current}
                    />
                    <button
                        type="button"
                        className="w-1/4 sm:w-1/6 shadow-md p-3 ml-3 bg-gray-500 text-white hover:bg-gray-400 transition-all uppercase font-bold rounded-lg"
                        onClick={() => setViewOpen(false)}
                    >
                        Salir
                    </button>
                </div>
            </div>
            {/*}
        <div className="w-full py-5 px-2 md:px-20 rounded-2xl">
            <h2 className='text-center text-gray-700 text-xl'>{`${props.tipo === 0 ?'Venta Nº '+ventaSelected.numerocomprobante:'Presupuesto Nº '+ventaSelected.numeropresupuesto} `}</h2>
            {ventaSelected.productos && (
                <table className='w-full md:w-3/4 mx-auto'>
                    <thead>
                        <tr className='p-1 bg-blue-400 text-white text-center'>
                            <th>Código</th>
                            <th>Descripción</th>
                            <th>Precio Unit.</th>
                            <th>Cantidad</th>
                            <th>Monto</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            ventaSelected.productos.map((item,index) => (
                                <tr key={index} className='border border-gray-300 p-2 text-center'>
                                    <td>{item.codigo}</td>
                                    <td>{item.descripcion}</td>
                                    <td>$ {(parseFloat(item.monto)/parseFloat(item.cantidad)).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                    <td>{item.cantidad}</td>
                                    <td>$ {parseFloat(item.monto).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                </tr>
                            ))
                        }
                        <tr className='border border-gray-300 p-2 text-center'>
                            <th colSpan={4}>Total</th>
                            <th>$ {parseFloat(total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</th>
                        </tr>
                    </tbody>
                </table>
            )}
            {ventaSelected.descuentos && (
                <div className='mt-5'>
                    <h3 className='text-center text-xl uppercase'>Descuentos</h3>
                    <table className='w-full md:w-3/4 mx-auto'>
                        <thead>
                            <tr className='p-1 bg-blue-400 text-white text-center'>
                                <th>Descripción</th>
                                <th>Monto</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                ventaSelected.descuentos.map(item => (
                                    <tr className='border border-gray-300 p-2 text-center'>
                                        <td>{item.descripcion}</td>
                                        <td>$ {parseFloat(item.monto).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            )}
            <div className='mt-5 w-3/4 mx-auto bg-green-300 rounded-xl p-3'>
                <p className='text-gray-600 text-2xl text-center font-semibold'>Medio de Pago: {ventaSelected.medio}</p>
            </div>
            <div className="w-full rounded-lg px-3 flex justify-center mt-10">
                <button
                    type="button"
                    className="w-1/4 sm:w-1/6 shadow-md p-3 ml-3 bg-gray-500 text-white hover:bg-gray-400 transition-all uppercase font-bold rounded-lg"
                    onClick={() => setViewOpen(false)}
                >
                    Salir
                </button>
            </div>
        </div>
        {*/}
        </>
    )
}

export default ViewVenta